import { makeAutoObservable } from "mobx"
import Assignment from "../models/Assignment"
import Package from "../../../models/Package"
import { Section } from "../models/Section"

export default class AssignmentCollection {
  items: Assignment[]

  constructor(assignments: Assignment[]) {
    makeAutoObservable(this, {}, { autoBind: true })

    this.items = assignments
    this.sortByName()
  }

  get length(): number {
    return this.items.length
  }

  filter = (filterFn) => {
    const newItems = this.items.filter(filterFn)
    return new AssignmentCollection(newItems)
  }

  search = (queryStr: string) => {
    if (queryStr != "") {
      const regex = new RegExp(queryStr, "i")
      return this.filter((a: Assignment) => a.passengerName.match(regex))
    } else {
      return this
    }
  }

  availableForSection(section: Section, showOnlyPassengersMatchingSectionPreferences: boolean): AssignmentCollection {
    let availableAssignments: AssignmentCollection = this.unassignedAssignments()

    if (showOnlyPassengersMatchingSectionPreferences && section.preferredGender) {
      availableAssignments = availableAssignments.filter(
        (a: Assignment) => a.gender === section.preferredGender || a.gender === "x",
      )
    }

    if (showOnlyPassengersMatchingSectionPreferences && section.preferredPackage) {
      availableAssignments = availableAssignments.filter((a: Assignment) => {
        return a?.package?.id === section.preferredPackage.id
      })
    }

    return availableAssignments
  }

  sortByName() {
    this.items = this.items.slice().sort((a1, a2) => a1.passengerName.localeCompare(a2.passengerName))
  }

  unassignedAssignments: () => AssignmentCollection = () =>
    this.filter(
      (a: Assignment) =>
        a.sectionId == undefined && a.participation.cancelled == false && a.participation.waitlistStatus.onWaitlist == false,
    )

  unassignedWithoutPackageSet: () => AssignmentCollection = () =>
    this.filter(
      (a: Assignment) =>
        a.sectionId == undefined &&
        a.participation.cancelled == false &&
        a.participation.waitlistStatus.onWaitlist == false &&
        a.package === undefined,
    )

  unassignedCountsByGender() {
    const unassignedMalesCount: number = this.unassignedAssignments().filter((a: Assignment) => a.gender === "male").length
    const unassignedFemalesCount: number = this.unassignedAssignments().filter(
      (a: Assignment) => a.gender === "female",
    ).length
    const unassignedXCount: number = this.unassignedAssignments().filter((a: Assignment) => a.gender === "x").length
    const unassignedMissingGenderCount: any = this.unassignedAssignments().filter(
      (a: Assignment) => a.gender === undefined,
    ).length
    return {
      unassignedMalesCount: unassignedMalesCount,
      unassignedFemalesCount: unassignedFemalesCount,
      unassignedXCount: unassignedXCount,
      unassignedMissingGenderCount: unassignedMissingGenderCount,
    }
  }

  unassignedWithPackage: (p: Package) => AssignmentCollection = (p) => {
    return this.unassignedAssignments().filter((a: Assignment) => a.package?.id && a.package?.id === p.id)
  }
}
